module.exports = "pegasus_template/assets/hexagon-snapchat.png";